var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 6.21875H4.58333H19.25",
    stroke: "black",
    strokeWidth: 1.87305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4173 6.21859V19.6353C17.4173 20.1436 17.2242 20.6311 16.8803 20.9905C16.5365 21.35 16.0702 21.5519 15.584 21.5519H6.41732C5.93109 21.5519 5.46477 21.35 5.12096 20.9905C4.77714 20.6311 4.58398 20.1436 4.58398 19.6353V6.21859M7.33398 6.21859V4.30192C7.33398 3.79359 7.52714 3.30608 7.87096 2.94663C8.21477 2.58719 8.68109 2.38525 9.16732 2.38525H12.834C13.3202 2.38525 13.7865 2.58719 14.1303 2.94663C14.4742 3.30608 14.6673 3.79359 14.6673 4.30192V6.21859",
    stroke: "black",
    strokeWidth: 1.87305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.79160bdd50484cd82ce8e185710b91f1.svg";
export { ForwardRef as ReactComponent };